var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInlineSwxShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "swx_short",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 127.1 91.2",
    style: {
      enableBackground: "new 0 0 127.1 91.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SOFWERX Abbreviated") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.1,52.1c0.1,3,1.5,4.7,4.4,4.9v5.9c-8-0.3-11.9-3.9-11.9-10.9H15.1z M33,54.2c0,5.6-3.9,8.5-11.6,8.7V57c2.6-0.2,3.9-1.2,3.9-2.8c-0.2-1.1-0.9-2.1-2-3c-2-1.5-3.8-2.9-5.6-4.2c-1.7-1.3-3.4-2.5-5.1-3.6c-2.3-1.8-3.8-4.3-4.3-7.2c0-5.7,3.7-8.7,11.2-8.9v5.8c-1.3,0.1-2.2,0.5-2.6,1c-0.5,0.5-0.7,1.3-0.7,2.3c0,1,0.4,1.7,1.2,2.2c0.5,0.3,1.2,0.7,1.9,1.2c0.7,0.5,1.5,1,2.4,1.6c0.8,0.6,1.6,1.1,2.4,1.7c0.8,0.6,1.5,1.1,2.2,1.6c0.6,0.5,1.2,0.8,1.6,1.1c0.4,0.3,0.6,0.4,0.6,0.4C31.4,48.5,33,51.1,33,54.2z M24.8,37.3c0-2.4-1.1-3.8-3.4-4.1v-5.8c7.6,0.3,11.3,3.6,11.3,9.9H24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.1,42.6L74,28h7.4l-7.6,28.7L70.1,42.6z M48.2,28h-7.5l9.1,34.3H55l0,0l0,0l1.1-4.2l-2-7.5L48.2,28zM72.8,60.3l-0.5,1.9h-5.2l0,0l-0.1,0l-6-22.4l-4.1,15.4l-3.4-12.6L57.5,28h3.6h3.6l8.4,31.5L72.8,60.3L72.8,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.1,52.6l-4.3,9.6h-8.3l8.9-16.1L101.1,52.6z M96.9,28l19.7,34.3h-8.5L88.5,28H96.9z M115.8,28L107.2,43l-3.6-6.5l3.9-8.5H115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.1,22.1h-27l-1.2-1.3l-3.6,1.3l-4.4,0l0,0c0,0-1.4-1.8-3.1-3l2-7.3l0.1-0.2c0,0,0,0,0,0l0-0.1l0,0c-0.4-0.3-5.2-3.5-7.7-4.3l-4.8,5.7c0,0-1.4-1-5.7-1.6c-0.7-2.5-1.4-6-2-8.5c-1.4-0.3-9,0-9,0c0,0,0,0,0,0c-0.7,2.6-1.4,6.2-2.1,8.8c-2.6,0.2-5.5,1.5-5.5,1.5S44.7,7.5,44,7.2c-0.7-0.3-7.7,4.3-7.7,4.3l2,7.6c-0.9,0.8-2.5,2.3-3.2,3.1l-0.1,0l-4.1,0l-4.1-1.3l-1,1.3H3.5l0,3.4h119.6L123.1,22.1z M47.8,22.1c3.9-2.2,8.3-3.5,13.1-3.5c4.8,0,9.2,1.3,13.1,3.5L47.8,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M123.1,68l0-3.4H3.5l0,3.4l22.5,0l1,1.3l3.9-1.3h4.4c1,1.1,3.7,3.5,3.7,3.5l-2.6,7.1c0,0,6.9,4.6,7.7,4.3c0.7-0.3,4.9-5.8,4.9-5.8s3,1.3,5.5,1.5c0.7,2.6,1.4,5.2,2.1,7.8c0,0,7.4,0.3,8.9,0c0,0,0.1,0,0.1,0c0.7-2.5,1.3-5,2-7.6c4.3-0.7,5.7-1.6,5.7-1.6l4.8,5.7c2.7-0.9,7.8-4.4,7.8-4.4l-2.7-7c2-1.1,3.8-3.5,3.8-3.5h4.4l3.6,1.3l1.2-1.3L123.1,68zM60.9,72.5c-5.4,0-10.5-1.7-14.7-4.5h29.4C71.4,70.8,66.3,72.5,60.9,72.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInlineSwxShort);
export default __webpack_public_path__ + "static/media/inline-swx_short.c613d441e148a94b0db92cebb1ba8070.svg";
export { ForwardRef as ReactComponent };